import React from 'react';
import { motion } from 'framer-motion';
import { PageHero } from '../components/PageHero';
import { CTASection } from '../components/CTASection';
export function WhatWeDo() {
  const capabilities = [{
    title: 'ACTIVATION',
    description: 'Convert onboard video into anonymised passenger movement and dwell signals'
  }, {
    title: 'STANDARDISATION',
    description: 'Produce consistent, comparable outputs across vehicles and routes'
  }, {
    title: 'DECISION SUPPORT',
    description: 'Deliver real-time alerts and aggregated analytics for operations, planning and safety'
  }];
  return <>
      <PageHero eyebrow="WHAT WE DO" headline="Turning onboard data into passenger intelligence" data-id="element-310" />

      {/* Introduction */}
      <section className="bg-sure-black w-full py-24 md:py-32" data-id="element-311">
        <div className="max-w-[1600px] mx-auto px-6 md:px-12" data-id="element-312">
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="text-sure-gray text-lg md:text-xl font-light leading-relaxed max-w-3xl" data-id="element-313">
            Public transport systems already capture continuous onboard data.
            SURE AI converts that dormant data into standardised, decision-ready
            operational signals that support real-time control room actions and
            longer-term network planning.
          </motion.p>
        </div>
      </section>

      {/* Core Capabilities */}
      <section className="bg-sure-dark w-full py-24 md:py-32" data-id="element-314">
        <div className="max-w-[1600px] mx-auto px-6 md:px-12" data-id="element-315">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="text-sure-accent text-xs md:text-sm uppercase tracking-widest font-medium mb-16" data-id="element-316">
            Core Capabilities
          </motion.h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-317">
            {capabilities.map((capability, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8,
            delay: index * 0.1
          }} className="bg-[#1a1a1a] border-l-2 border-sure-accent p-8" data-id="element-318">
                <h3 className="text-sure-white text-base font-bold uppercase tracking-widest mb-4" data-id="element-319">
                  {capability.title}
                </h3>
                <p className="text-sure-gray text-sm font-light leading-relaxed" data-id="element-320">
                  {capability.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Proof Point */}
      <section className="bg-sure-black w-full py-24 md:py-32" data-id="element-321">
        <div className="max-w-[1600px] mx-auto px-6 md:px-12 text-center" data-id="element-322">
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="text-sure-white text-2xl md:text-3xl font-light italic leading-relaxed max-w-4xl mx-auto" data-id="element-323">
            "Designed for phased deployment alongside existing CCTV and
            telematics, SURE AI delivers outputs that are practical, auditable
            and aligned with operational workflows."
          </motion.p>
        </div>
      </section>

      <CTASection data-id="element-324" />
    </>;
}